<template>
  <transition>
    <div class="line-special-base fortune-input" v-if="initialized">
      <h1><span>{{headInfo.title}}</span></h1>
      <div class="head-talk">
        <div class="fuki">
          <fukidashi-base :fuki-text="headInfo.comment1" arrow-direction="right" />
        </div>
        <img :src="basicData.pictures.pic1" alt="" :class="`lp-id--${hokatotoId}`">
      </div>

      <div class="input-panel-base">
        <div class="input-panel">
          <div v-for="(item, idx) of componentData" :key="idx" class="input-field">
            <component
              :form-param="item.param"
              :is="item.component"
              :data-set="dataSet"
              @on-input="onInput"
            ></component>
          </div>

          <div class="btn-area">
            <span
              class="btn btn-submit"
              :class="{disable: buttonIsDisabled}"
              @click="onSubmitClick"
            >{{btnFace}}</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import InputBlockFullname from '@/utvStore/components/recommend/inputParts/InputBlockFullname'
import InputBlockBirthday from '@/utvStore/components/recommend/inputParts/InputBlockBirthday'
import InputBlockFromPref from '@/utvStore/components/recommend/inputParts/InputBlockFromPref'
import FukidashiBase from '@/utvStore/components/recommend/line_special/partials/FukidashiBase'
import { BASIC_DATA_BY_LPID } from '@/utvStore/components/recommend/lp/commons'

const PARAMS_INFO = [
  {param: 'fullname', component: InputBlockFullname },
  {param: 'birthday', component: InputBlockBirthday },
  {param: 'from_pref', component: InputBlockFromPref },
]

export default {
  name: 'LineSpecialInput',
  components: {
    FukidashiBase,
  },
  props: {
    itemsId: {
      type: Number,
      default: 0,
    },
    hokatotoId: {
      type: Number,
      default: 0,
    },
    token:{
      type: String,
      default: '',
    },
    formAction: {
      type: String,
      default: '',
    },
    headInfo: {
      type: Object,
      default(){
        return {}
      },
    },
    inputParams: {
      type: Array,
      default(){
        return []
      },
    },
  },
  data(){
    return {
      lock: false,
      initialized: false,
      btnFace: '占う',
      checkData: {},
      dataSet: [],
      formDataSet: {},
      buttonIsDisabled: false,
    }
  },
  computed: {
    basicData(){
      return BASIC_DATA_BY_LPID[+this.hokatotoId].information.lineSpecial
    },
    componentData(){
      const nameSet = {
        first_name: 'fullname',
        last_name: 'fullname',
      }
      const rtn = []
      if(Object.keys(this.checkData).length === 0){
        this.inputParams.forEach(item => {
          const setName = item in nameSet ? nameSet[item] : item
          const dt = PARAMS_INFO.find(item => item.param === setName)

          this.formDataSet[item] = ''

          if(dt) {
            this.$set(this.checkData, setName, {
              ...dt,
              disable: false,
            })
            if(!rtn.find(pitem => pitem.param === setName)){
              rtn.push(dt)
            }
          }
        })
      }
      return rtn
    },
  },
  watch: {
    checkData: {
      handler(){
        this.buttonIsDisabled = Object.keys(this.checkData).some(key => this.checkData[key].disable)
      },
      deep: true,
    },
  },
  mounted(){
    console.log('id[%s] hokatoto[%s] headInfo:%O inputParams:%O \nActionString[%s]', this.itemsId, this.hokatotoId, this.headInfo, this.inputParams, this.formAction)
    window.addEventListener('pageshow', this.onPageShow)
  },
  methods: {
    onPageShow(e){
      this.dataSet = this.inputParams.map(item => {
        return {key: item, value: ''}
      })
      setTimeout(()=>this.initialized = true, 500)
    },
    onInput(data){
      this.$set(this.checkData[data.key], 'disable', data.disable)
      for(let key in data.inputData){
        this.formDataSet[key] = data.inputData[key]
      }
    },
    onSubmitClick(e){
      if(!this.lock) {
        this.lock = true
        const frm = document.createElement('form')
        frm.method = 'post'
        frm.action = this.formAction
        this.$el.appendChild(frm)

        const tkn = document.createElement('input')
        tkn.name = '_token'
        tkn.type = 'hidden'
        tkn.value = this.token
        frm.appendChild(tkn)

        for (let key in this.formDataSet) {
          const inp = document.createElement('input')
          inp.name = key
          inp.type = 'hidden'
          inp.value = this.formDataSet[key]
          frm.appendChild(inp)
        }
        setTimeout(() => frm.submit(), 100)
      }
    },
  }
}</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";

.line-special-base {
  padding-top: 40px;
  padding-bottom: 60px;
  color: #32373f;

  @include mq('w580'){
    font-size: 1.2em;
    line-height: 1.8em;
  }

  h1 {
    margin: 0 20px 16px;
    text-align: center;
    font-size: 24px;
    span {
      display: inline-block;
      position: relative;
      padding: 0 4px 8px;
      &::after {
        content: "";
        width: 100%;
        background: #69EDB2;
        height: 4px;
        border-radius: 4px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
  }
  .head-talk {
    padding: 0 8px 0 0;
    position: relative;
    text-align: right;
    width: 100%;
    margin-bottom: -20px;
    .fuki{
      width: 52%;
      height: 100%;
      position: absolute;
      left: 20px;
      top: 0;
      z-index: 11;
      display: flex;
      align-items: center;
      padding-bottom: 20px;
    }
    img {
      position: relative;
      z-index: 10;
      display: inline-block;
      width: 45%;
      &.lp-id--5 { width: 56%; margin-right: -8px; }
    }
  }

  .input-panel-base {
    position: relative;
    z-index: 10;
    padding: 0 20px 0;
    .input-panel {
      background: url(/static/img/recommend/line_special/bg_lineSp01.png) no-repeat center center;
      background-size: 100% auto;
      padding: 40px 32px 32px;
      border-radius: 16px;

      /deep/ {
        .form-input__input,
        .calenderForm {
          background: white;
          border: 0;
          border-radius: 5px;
        }
        .calenderForm {
          width: 100%;
          padding-right: 50%;
          @include mq('w580') {
            padding-right: 70%;
          }
        }
        select {
          background-color: white;
          border: none;
        }
        .form-input__error-message {
          color: red;
          text-shadow: none;
        }
      }

      .btn-area {
        width: 100%;
        padding-top: 16px;
        .btn {
          width: 100%;
          height: 55px;
          border: none;
          background: white;
          border-radius: 30px;
          font-weight: bold;
          color: #32373f;
          line-height: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
          cursor: pointer;
          transition: all 200ms ease-out 0s;
          max-width: 300px;
          margin: 0 auto;
          &.disable {
            color: #dadada;
            pointer-events: none;
            filter: none;
          }
        }
      }

    }
  }

}

.v-enter-active,
.v-leave-active {
  transition: all 200ms ease-out 0s;
}

.v-enter, .v-leave-to {
  opacity: 0;
}

.v-enter-to, .v-leave {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/utvStore/components/recommend/line_special/LineSpecialInput.vue